import React from 'react';

function Custombarcode() {
  return (
    <>
      <div className='flex'>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
        <div className="w-1 h-16 bg-black ml-1"></div>
     </div>

      <div className="text-md">123456789012</div>
    </>
  );
}

export default Custombarcode;
